import { Link } from "react-router-dom";
import { DropdownMenuItem } from "@/components/ui/dropdown-menu";
import { cn } from "@/lib/utils";
import type { NavLink } from "./nav-config";

interface NavDropdownContentProps {
  links: NavLink[];
  currentPath: string;
  onSelect?: () => void;
}

export function NavDropdownContent({
  links,
  currentPath,
  onSelect,
}: NavDropdownContentProps) {
  return (
    <div className="grid gap-1">
      {links.map((link) => {
        const isActive =
          currentPath === link.to || currentPath.startsWith(`${link.to}/`);

        return (
          <DropdownMenuItem key={link.to} asChild className="p-0">
            <Link
              to={link.to}
              onClick={onSelect}
              className={cn(
                "flex items-start gap-3 rounded-md p-3 text-sm w-full",
                "hover:bg-accent hover:text-accent-foreground",
                "focus:bg-accent focus:text-accent-foreground focus:outline-none",
                isActive && "bg-accent text-accent-foreground"
              )}
            >
              {/* Ikoni */}
              <div className="flex h-8 w-8 shrink-0 items-center justify-center rounded-md border bg-background">
                <link.icon className="h-4 w-4" />
              </div>

              {/* Teksti */}
              <div className="flex flex-col gap-0.5">
                <span
                  className={cn(
                    "font-medium leading-none",
                    isActive && "text-accent-foreground"
                  )}
                >
                  {link.label}
                </span>
                {link.description && (
                  <span className="line-clamp-2 text-xs text-muted-foreground">
                    {link.description}
                  </span>
                )}
              </div>
            </Link>
          </DropdownMenuItem>
        );
      })}
    </div>
  );
}
